import { render, staticRenderFns } from "./previewHandbookSiyan.vue?vue&type=template&id=b525ee80&scoped=true"
import script from "./previewHandbookSiyan.vue?vue&type=script&lang=js"
export * from "./previewHandbookSiyan.vue?vue&type=script&lang=js"
import style0 from "./previewHandbookSiyan.vue?vue&type=style&index=0&id=b525ee80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b525ee80",
  null
  
)

export default component.exports